import * as React from "react"
import GenericConfirmationModal from "../../molecules/modals/GenericConfirmationModal"

interface TurnOnTxModalProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
}

const TurnOnTxModal: React.FunctionComponent<TurnOnTxModalProps> = ({ open, onClose, onConfirm }) => {
  return (
    <GenericConfirmationModal
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title={"Turn transmission on"}
      message={`
      Turning transmission on will connect the terminal to the satellite and enable internet access.
      `}
      confirmText={"Turn transmission on"}
    />
  )
}

export default TurnOnTxModal
